import { useState } from 'react';

import LoadingButton from '@mui/lab/LoadingButton';
import { Box, Button, Stack, Typography } from '@mui/material';

import { useMutation } from '@redwoodjs/web';

import { EmailRecipientsInput } from 'src/components/EmailRecipientsInput';
import { showErrorToast, showSuccessToast } from 'src/components/Toasts/toast';
import { RESEND_SELF_BILLING_INVOICE } from 'src/graphql/mutations/selfBillingInvoice.mutation';

type SendSelfBillingInvoiceModalProps = {
    handleCloseSendModal: () => void;
    invoiceId: number;
    partnerBillingContactEmail: string;
};

export const SendSelfBillingInvoiceModal = ({
    handleCloseSendModal,
    invoiceId,
    partnerBillingContactEmail,
}: SendSelfBillingInvoiceModalProps) => {
    const [sendRecipients, setSendRecipients] = useState<string[]>([partnerBillingContactEmail]);

    const [resendSelfBillingInvoice, { loading }] = useMutation(RESEND_SELF_BILLING_INVOICE, {
        variables: { id: invoiceId, recipients: sendRecipients },
        onCompleted: (data) => {
            if (data) {
                showSuccessToast(`Self-billing Invoice sent successfully!`);
                handleCloseSendModal();
            }
        },
        onError: (err) => {
            showErrorToast(err.message);
        },
    });

    const handleResendInvoice = async () => {
        resendSelfBillingInvoice({ id: invoiceId });
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
            }}
        >
            <Typography
                sx={{
                    fontSize: '16px',
                    color: '#667085',
                    marginBottom: '16px',
                }}
            >
                Are you sure you want to resend this invoice?
            </Typography>
            <Box sx={{ marginTop: '30px' }}>
                <EmailRecipientsInput
                    sendRecipients={sendRecipients}
                    setSendRecipients={setSendRecipients}
                />
            </Box>
            <Stack direction="row" justifyContent={'center'} spacing={2} sx={{ mt: 3 }}>
                <Button
                    variant="outlined-black"
                    onClick={handleCloseSendModal}
                    fullWidth
                    sx={{ width: '170px', height: '44px' }}
                >
                    Close
                </Button>

                <LoadingButton
                    variant="main"
                    onClick={handleResendInvoice}
                    fullWidth
                    loading={loading}
                    disabled={sendRecipients.length < 1}
                    sx={{ width: '170px', height: '44px' }}
                >
                    Send
                </LoadingButton>
            </Stack>
        </Box>
    );
};
